import Image from "next/image"
import uorLogo from '../../../../images/logos/uor.svg'

export function Logo() {
  return <Image
    alt="Universal Orlando Resort"
    src={uorLogo}
    priority
    width={0}
    height={0}
  />
}
